import React from 'react'
import "./Online.css"

function Online() {
  return (
    <li className="rightbarfriend">
    <div className="rightbarProfileImgContainer">
        <img className='rightbarProfileImg' src="./assets/haseeb_edited_edited.jpg" alt="" />
        <span className='rightbarOnline'></span>
    </div>
    <span className="rightbarUsername">evan</span>
</li>
  )
}

export default Online
